import { Text } from '@/shared/ui'
import Flex from '@/shared/ui/Flex'

import cl from './product-spec-item.module.scss'

export const ProductSpecItem = ({ name, value, link }: { name: string; value: string; link?: string }): JSX.Element => (
	<div className={cl.specItem}>
		<Flex alignEnd wrap>
			<Text as="dt">{name}</Text>
			<hr className={cl[`specItem--underLine`]} />
			{!link && <Text as="dd">{value}</Text>}
		</Flex>
	</div>
)
